import { render, staticRenderFns } from "./AdminFaqNew.vue?vue&type=template&id=427bbd6a&scoped=true"
import script from "./AdminFaqNew.vue?vue&type=script&lang=js"
export * from "./AdminFaqNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427bbd6a",
  null
  
)

export default component.exports